import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BrushIcon from "@mui/icons-material/Brush";
import CloudIcon from "@mui/icons-material/Cloud";
import DevicesIcon from "@mui/icons-material/Devices";
import StorageIcon from "@mui/icons-material/Storage";
import WebIcon from "@mui/icons-material/Web";
import { Box, Container, Grid, Link, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { designTokens } from "../../../theme/designTokens";
import { technologyServices } from "../../../theme/homeContent";
import SectionHeading from "../shared/SectionHeading";

const { colors, borderRadius, fontSizes } = designTokens;

const serviceIcons = [
  <AutoAwesomeIcon />,
  <BrushIcon />,
  <StorageIcon />,
  <CloudIcon />,
  <DevicesIcon />,
  <WebIcon />,
];

const TechnologyServices = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: designTokens.spacing.sectionPy, backgroundColor: colors.backgroundAlt }}>
      <Container maxWidth={designTokens.spacing.containerMax}>
        <SectionHeading
          label="OUR SERVICES"
          title="Technology Services"
          highlight="That Drive Real Impact"
          subtitle="We combine cutting-edge technology with deep domain expertise to deliver solutions that transform how businesses operate and grow"
        />
        <Grid container spacing={3}>
          {technologyServices.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={service.title}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  height: "100%",
                  border: `1px solid ${colors.border}`,
                  borderRadius: borderRadius.card,
                  backgroundColor: colors.background,
                }}
              >
                <Box sx={{ color: colors.primary, mb: 2, "& svg": { fontSize: 28 } }}>
                  {serviceIcons[index]}
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>
                  {service.title}
                </Typography>
                <Typography variant="body2" sx={{ color: colors.textSecondary, lineHeight: 1.7, mb: 2 }}>
                  {service.description}
                </Typography>
                <Link
                  component="button"
                  onClick={() => navigate(service.path)}
                  sx={{
                    color: colors.primary,
                    fontWeight: 700,
                    fontSize: fontSizes.sm,
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    cursor: "pointer",
                    border: "none",
                    background: "none",
                    p: 0,
                    textTransform: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Learn more
                  <ArrowForwardIcon sx={{ fontSize: 14 }} />
                </Link>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TechnologyServices;
